<div #outsideModal class="modal" id="modal-presend-cda">
  <div #modalBody class="modal-content">
    <div class="modal-header">Informations complémentaires du document</div>
    <div class="modal-body">
      <frg-form-input label="Titre du document" id="titreDocument"
        type="text" [formGroup]="formGroup" [control]="formGroup.get('titreDocument')">
      </frg-form-input>
      <frg-form-input label="Description du document" id="descriptionDocument"
        type="text" [formGroup]="formGroup" [control]="formGroup.get('descriptionDocument')">
      </frg-form-input>
      <frg-form-input label="Classe du document" id="classDocument"
        type="ngSelect" [selectValue]="classDocuments" [formGroup]="formGroup"
        [control]="formGroup.get('classDocument')">
      </frg-form-input>
      <frg-form-input label="Type du document" id="typeDocument"
        type="ngSelect" [selectValue]="typeDocuments" [formGroup]="formGroup"
        [control]="formGroup.get('typeDocument')">
      </frg-form-input>
      <frg-form-input label="Format du document" id="formatDocument"
        type="ngSelect" [selectValue]="formatDocuments" [formGroup]="formGroup"
        [control]="formGroup.get('formatDocument')">
      </frg-form-input>
      <frg-form-input label="Type d'activité" id="typeActivite"
        type="ngSelect" [selectValue]="typeActivites" [formGroup]="formGroup"
        [control]="formGroup.get('typeActivite')">
      </frg-form-input>
      <div class="button-container">
        <frg-button (activated)="validate()" [disabled]="!formGroup.valid">
          <div title="Valider">Valider</div>
        </frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>
